import { useTenantRuntime } from "../config/TenantRuntime";
import { Card, Field, Button, Badge } from "../components/ui";

export function SettingsPage() {
  const { tenant, modules } = useTenantRuntime();
  return (
    <div className="settings-grid">
      <Card title="Empresa e tenant">
        <div className="form-grid">
          <Field label="Nome fantasia">
            <input defaultValue={tenant.organization.tradeName} />
          </Field>
          <Field label="Slug">
            <input defaultValue={tenant.slug} disabled />
          </Field>
          <Field label="Fuso horário">
            <input defaultValue={tenant.organization.timezone} />
          </Field>
          <Field label="Plano">
            <input defaultValue={tenant.product.planCode} disabled />
          </Field>
        </div>
        <div className="card-actions">
          <Button>Salvar configurações</Button>
        </div>
      </Card>

      <Card title="Módulos habilitados">
        <div className="module-badges">
          {modules.map((module) => (
            <Badge key={module} tone="info">
              {module}
            </Badge>
          ))}
        </div>
      </Card>

      <Card title="Gate de produção">
        <ul className="feature-list">
          <li>Preço aprovado: {tenant.businessConfig.pricingApproved ? "sim" : "pendente"}</li>
          <li>Split aprovado: {tenant.businessConfig.splitApproved ? "sim" : "pendente"}</li>
          <li>
            Comissão aprovada: {tenant.businessConfig.commissionApproved ? "sim" : "pendente"}
          </li>
          <li>
            Contratos aprovados: {tenant.businessConfig.legalDocumentsApproved ? "sim" : "pendente"}
          </li>
          <li>Migração aprovada: {tenant.businessConfig.migrationApproved ? "sim" : "pendente"}</li>
        </ul>
      </Card>
    </div>
  );
}
